import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'block-header',
  template: `
    <div class="m-t-lg">
      <h4 style="font-weight: bolder;">{{ title }}</h4>
    </div>
    <div *ngIf="subTitle" [style.color]="subTitleColor">
      <h5>
        <i class="fa fa-info-circle" aria-hidden="true"></i> <em>{{ subTitle }}</em>
      </h5>
    </div>
  `
})
export class BlockHeaderComponent implements OnInit {
  @Input() public title: string;
  @Input() public subTitle: string;
  @Input() public subTitleColor: string = 'inherit';

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/block-header/block-header.component.ts